import { Button } from "@/components/ui/button";

const HeroSection = () => {
  return (
    <section id="home" className="relative bg-gradient-to-r from-wiiseng-navy to-wiiseng-blue text-white py-20 md:py-32 overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-full">
        <div className="absolute top-10 right-10 w-40 h-40 rounded-full bg-white opacity-5"></div>
        <div className="absolute bottom-10 left-10 w-60 h-60 rounded-full bg-white opacity-5"></div>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            CNC Machine Repair & Maintenance
          </h1>
          
          <div className="mb-8 space-y-4">
            <p className="text-lg md:text-xl opacity-90">
              Reliable repair, maintenance, and retrofitting for multi-axis CNC machines,
              keeping your shop running with 20+ years of hands-on experience.
            </p>
            <p className="text-lg md:text-xl opacity-90">
              为多轴 CNC 机床提供维修、保养与改造服务，拥有20多年实战经验，让您的车间稳定运转
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              size="lg" 
              className="bg-white text-wiiseng-navy hover:bg-gray-100"
              onClick={() => document.getElementById('services')?.scrollIntoView({behavior: 'smooth'})}
            >
              Our Services
            </Button>
            <Button 
              size="lg" 
              variant="outline" 
              className="border-white text-white bg-wiiseng-blue/30 hover:bg-white/20"
              onClick={() => document.getElementById('contact')?.scrollIntoView({behavior: 'smooth'})}
            >
              Contact Us
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
